module.exports = __webpack_public_path__ + "static/media/8OLA23.73b993e5.jpg";